import React, { Fragment, useRef } from 'react';
import PropTypes from 'prop-types';
import QRCode from 'qrcode.react';

import { getAsset } from '../../../../../../../../util/assets';
import useComponentSize from '../../../../../../../../hooks/useComponentSize';
import getConfig from '../../../../../../../../util/config';
import { getUtmParamsForQrCodeUrl } from '../helpers';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string,
    onboarding_short_url: PropTypes.string,
    has_video_album: PropTypes.bool,
    is_web_gallery: PropTypes.bool,
  }),
};

const AccountMarketingMaterialShutterbugFlyerTemplate = ({ albumFolder }) => {
  const templateRef = useRef(null);
  const { width } = useComponentSize(templateRef);
  const url = albumFolder.is_web_gallery
    ? `${getConfig().app.baseUrl}/galleries/view/folder/${albumFolder.id}`
    : albumFolder.onboarding_short_url;

  return (
    <Fragment>
      <div
        style={{
          top: '59.5%',
          left: '36%',
          bottom: '39.3%',
          right: '16.1%',
        }}
        className="marketing-material-shutterbug-flyer-qrcode"
      >
        <QRCode
          renderAs="canvas"
          value={getUtmParamsForQrCodeUrl({
            url,
            albumFolder,
          })}
          size={width * 0.29 ?? 232}
        />
      </div>

      <img
        ref={templateRef}
        src={getAsset(
          albumFolder.has_video_album
            ? '/marketing-material/MARKETING_MATERIAL_SHUTTERBUG_FLYER_TEMPLATE_VGB.png'
            : '/marketing-material/MARKETING_MATERIAL_SHUTTERBUG_FLYER_TEMPLATE.png',
        )}
        alt=""
      />
      {!albumFolder?.purchased_event?.features
        ?.white_label_marketing_prints_enabled && (
        <img
          src={getAsset('/powered-by-waldo-blue.svg')}
          alt=""
          style={{
            position: 'absolute',
            bottom: '2%',
            right: '2%',
            width: '10%',
          }}
        />
      )}
    </Fragment>
  );
};

AccountMarketingMaterialShutterbugFlyerTemplate.propTypes = propTypes;

export default AccountMarketingMaterialShutterbugFlyerTemplate;
